import { render, staticRenderFns } from "./TeleMarketFollowUpRecord.vue?vue&type=template&id=ffd0ec32&scoped=true"
import script from "./TeleMarketFollowUpRecord.vue?vue&type=script&lang=js"
export * from "./TeleMarketFollowUpRecord.vue?vue&type=script&lang=js"
import style0 from "./TeleMarketFollowUpRecord.vue?vue&type=style&index=0&id=ffd0ec32&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffd0ec32",
  null
  
)

export default component.exports